import {UpmDepartment} from '../../types'

import {useSettingsQuery} from '@settings/modules/common/providers'
import {PlantNode} from '@hconnect/common/types'
import {useUrlParam} from '@settings/modules/routing'

export function extractDepartmentsWithEquipments(plant: PlantNode): UpmDepartment[] {
  const departments: UpmDepartment[] = []

  plant.children.forEach((area) => {
    area.children.forEach((prodLine) => {
      prodLine.children.forEach((department) => {
        const label = department.displayValue ?? department.text ?? department.type?.name

        if (label) {
          departments.push({
            id: department.upmId,
            label
          })
        }
      })
    })
  })

  return departments
}

export const useUpmDepartmentOptionsQuery = ({
  includeEquipment,
  product
}: {
  includeEquipment: boolean
  product?: string
  upmId?: string | undefined
}) => {
  const plantCode = useUrlParam('plantCode')

  return useSettingsQuery('upmStructure', [plantCode, includeEquipment, product], {
    staleTime: Infinity,
    placeholderData: (prev) => prev,
    select: extractDepartmentsWithEquipments
  })
}
